/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1656
 */

require(/* 86 */"./1650/86/index")({
  target: "Number",
  stat: true
}, {
  MIN_SAFE_INTEGER: -9007199254740991
})
